module.exports = __webpack_public_path__ + "img/jcb.2d5a16d8.svg";